import { ACTIONS } from '~/redux/actions/actions'
import updatePusherConnectionState from '~/redux/reducers/utils/updatePusherConnectionState'

export default { [ACTIONS.UPDATE_PUSHER_CONNECTION_STATE]: updatePusherConnectionState }
